export enum GiftType {
  InHonorOf = 1,
  InMemoryOf = 2,
  InSupportOf = 3,
}
